import { render, staticRenderFns } from "./SupplementaryIcon.vue?vue&type=template&id=295002c8&scoped=true"
import script from "./SupplementaryIcon.vue?vue&type=script&lang=js"
export * from "./SupplementaryIcon.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryIcon.vue?vue&type=style&index=0&id=295002c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295002c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295002c8')) {
      api.createRecord('295002c8', component.options)
    } else {
      api.reload('295002c8', component.options)
    }
    module.hot.accept("./SupplementaryIcon.vue?vue&type=template&id=295002c8&scoped=true", function () {
      api.rerender('295002c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/SupplementaryIcon.vue"
export default component.exports